import { render, staticRenderFns } from "./bulma_graphprops.vue?vue&type=template&id=13305288"
import script from "./bulma_graphprops.vue?vue&type=script&lang=js"
export * from "./bulma_graphprops.vue?vue&type=script&lang=js"
import style0 from "./bulma_graphprops.vue?vue&type=style&index=0&id=13305288&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports